import parseISO from 'date-fns/parseISO'
import formatDate from "@utils/format-date";

export function couponDateRange({ startDate = '', endDate = '' } = {}) {
  const formatStartDate = startDate
    ? formatDate(parseISO(startDate), 'yyyy/MM/dd')
    : '即日起';
  const formatEndDate = endDate
    ? formatDate(parseISO(endDate), 'yyyy/MM/dd')
    : '不限時間';

  return startDate && endDate
    ? [
      formatStartDate,
      formatEndDate
    ].join('~')
    : '無使用期限'
}
